import React, { useEffect, useState } from 'react';
import { CalendarDays, User } from 'lucide-react';
import { obtenerFechaActualLocal } from '../../utils/dateUtils';

// Datos de provincias y cantones de Ecuador
const provinciasEcuador = {
  'Azuay': ['Cuenca', 'Girón', 'Gualaceo', 'Nabón', 'Paute', 'Pucará', 'San Fernando', 'Santa Isabel', 'Sevilla de Oro', 'Sígsig', 'Oña', 'Chordeleg', 'El Pan', 'Guachapala', 'Camilo Ponce Enríquez'],
  'Bolívar': ['Guaranda', 'Chillanes', 'Chimbo', 'Echeandía', 'San Miguel', 'Caluma', 'Las Naves'],
  'Cañar': ['Azogues', 'Biblián', 'Cañar', 'La Troncal', 'El Tambo', 'Déleg', 'Suscal'],
  'Carchi': ['Tulcán', 'Bolívar', 'Espejo', 'Mira', 'Montúfar', 'San Pedro de Huaca'],
  'Chimborazo': ['Riobamba', 'Alausí', 'Colta', 'Chambo', 'Chunchi', 'Guamote', 'Guano', 'Pallatanga', 'Penipe', 'Cumandá'],
  'Cotopaxi': ['Latacunga', 'La Maná', 'Pangua', 'Pujilí', 'Salcedo', 'Saquisilí', 'Sigchos'],
  'El Oro': ['Machala', 'Arenillas', 'Atahualpa', 'Balsas', 'Chilla', 'El Guabo', 'Huaquillas', 'Marcabelí', 'Pasaje', 'Piñas', 'Portovelo', 'Santa Rosa', 'Zaruma', 'Las Lajas', 'La Victoria'],
  'Esmeraldas': ['Esmeraldas', 'Eloy Alfaro', 'Muisne', 'Quinindé', 'San Lorenzo', 'Atacames', 'Rioverde', 'La Concordia'],
  'Galápagos': ['San Cristóbal', 'Isabela', 'Santa Cruz'],
  'Guayas': ['Guayaquil', 'Alfredo Baquerizo Moreno', 'Balao', 'Balzar', 'Colimes', 'Daule', 'Duran', 'El Empalme', 'El Triunfo', 'Milagro', 'Naranjal', 'Naranjito', 'Nobol', 'Palestina', 'Pedro Carbo', 'Samborondón', 'Santa Lucía', 'Salitre', 'San Jacinto de Yaguachi', 'Playas', 'Simón Bolívar', 'Coronel Marcelino Maridueña', 'Lomas de Sargentillo', 'Nobol', 'General Antonio Elizalde', 'Isidro Ayora'],
  'Imbabura': ['Ibarra', 'Antonio Ante', 'Cotacachi', 'Otavalo', 'Pimampiro', 'San Miguel de Urcuquí'],
  'Loja': ['Loja', 'Calvas', 'Catamayo', 'Celica', 'Chaguarpamba', 'Espíndola', 'Gonzanamá', 'Macará', 'Paltas', 'Puyango', 'Zapotillo', 'Pindal', 'Quilanga', 'Olmedo', 'Sozoranga'],
  'Los Ríos': ['Babahoyo', 'Baba', 'Montalvo', 'Puebloviejo', 'Quevedo', 'Urdaneta', 'Ventanas', 'Vínces', 'Palenque', 'Buena Fé', 'Valencia', 'Mocache', 'Quinsaloma'],
  'Manabí': ['Portoviejo', 'Bolívar', 'Chone', 'El Carmen', 'Flavio Alfaro', 'Jipijapa', 'Junín', 'Manta', 'Montecristi', 'Paján', 'Pichincha', 'Rocafuerte', 'Santa Ana', 'Sucre', 'Tosagua', '24 de Mayo', 'Pedernales', 'Olmedo', 'Puerto López', 'Jama', 'Jaramijó', 'San Vicente'],
  'Morona Santiago': ['Macas', 'Gualaquiza', 'Limón Indanza', 'Palora', 'Santiago', 'Sucúa', 'Huamboya', 'San Juan Bosco', 'Taisha', 'Logroño', 'Pablo Sexto', 'Tiwintza'],
  'Napo': ['Tena', 'Archidona', 'El Chaco', 'Quijos', 'Carlos Julio Arosemena Tola'],
  'Orellana': ['Orellana', 'Aguarico', 'La Joya de los Sachas', 'Loreto'],
  'Pastaza': ['Pastaza', 'Mera', 'Santa Clara', 'Arajuno'],
  'Pichincha': ['Quito', 'Cayambe', 'Mejía', 'Pedro Moncayo', 'Rumiñahui', 'San Miguel de los Bancos', 'Pedro Vicente Maldonado', 'Puerto Quito'],
  'Santa Elena': ['Santa Elena', 'La Libertad', 'Salinas'],
  'Santo Domingo de los Tsáchilas': ['Santo Domingo', 'La Concordia'],
  'Sucumbíos': ['Nueva Loja', 'Cascales', 'Cuyabeno', 'Gonzalo Pizarro', 'Putumayo', 'Shushufindi', 'Sucumbíos'],
  'Tungurahua': ['Ambato', 'Baños de Agua Santa', 'Cevallos', 'Mocha', 'Patate', 'Quero', 'San Pedro de Pelileo', 'Santiago de Píllaro', 'Tisaleo'],
  'Zamora Chinchipe': ['Zamora', 'Chinchipe', 'Nangaritza', 'Yacuambi', 'Yantzaza', 'El Pangui', 'Centinela del Cóndor', 'Palanda', 'Paquisha']
};

const DatosPersonales = ({ formData, setFormData, handleInputChange, errors }) => {
    const [age, setAge] = useState({ years: 0, months: 0 });
    const [localErrors, setLocalErrors] = useState({});
    const [tieneCedula, setTieneCedula] = useState(!formData.noCedula);
    const [paisNacimiento, setPaisNacimiento] = useState('');
    const [provinciaNacimiento, setProvinciaNacimiento] = useState('');
    const [cantonNacimiento, setCantonNacimiento] = useState('');
    const [otroPaisNacimiento, setOtroPaisNacimiento] = useState('');

    const PREDEFINED_PASA_TIEMPO_OPTIONS = ['madre', 'padre', 'abuelos', 'tios', 'hermanos'];
    const PREDEFINED_VIVE_CON_OPTIONS = ['padre', 'madre', 'padre y madre', 'abuelos', 'tios'];

    const [pasaTiempoConSelection, setPasaTiempoConSelection] = useState('');
    const [viveConSelection, setViveConSelection] = useState('');

    useEffect(() => {
        if (PREDEFINED_PASA_TIEMPO_OPTIONS.includes(formData.pasaTiempoCon)) {
            setPasaTiempoConSelection(formData.pasaTiempoCon);
        } else if (formData.pasaTiempoCon) { // It's custom text
            setPasaTiempoConSelection('otra');
        } else {
            setPasaTiempoConSelection(''); // Default empty selection
        }
    }, [formData.pasaTiempoCon]);

    useEffect(() => {
        if (PREDEFINED_VIVE_CON_OPTIONS.includes(formData.viveCon)) {
            setViveConSelection(formData.viveCon);
        } else if (formData.viveCon) { // It's custom text
            setViveConSelection('otra');
        } else {
            setViveConSelection('');
        }
    }, [formData.viveCon]);

    const customHandleInputChange = (e) => {
        const { name, value } = e.target;
        
        if (name === 'pasaTiempoCon_select') {
            setPasaTiempoConSelection(value);
            if (value === 'otra') {
                setFormData(prev => ({
                    ...prev,
                    pasaTiempoCon: prev.pasaTiempoOtra || ''
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    pasaTiempoCon: value,
                    pasaTiempoOtra: ''
                }));
            }
        } 
        else if (name === 'pasaTiempoOtra') {
            setFormData(prev => ({
                ...prev,
                pasaTiempoOtra: value,
                pasaTiempoCon: value
            }));
        }
        else if (name === 'viveCon_select') {
            setViveConSelection(value);
            if (value === 'otra') {
                setFormData(prev => ({
                    ...prev,
                    viveCon: prev.viveConOtra || ''
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    viveCon: value,
                    viveConOtra: ''
                }));
            }
        }
        else if (name === 'viveConOtra') {
            setFormData(prev => ({
                ...prev,
                viveConOtra: value,
                viveCon: value 
            }));
        }
        else {
            handleInputChange(e); 
        }
    };

    const calculateAndValidateAge = () => {
        if (formData.fechaNacimiento) {
            const birthDate = new Date(formData.fechaNacimiento);
            const today = new Date();

            if (birthDate > today) {
                setAge({ years: 0, months: 0 });
                setLocalErrors(prev => ({
                    ...prev,
                    fechaNacimiento: 'La fecha de nacimiento no puede ser mayor a la fecha actual'
                }));
                return;
            } else {
                setLocalErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors.fechaNacimiento;
                    return newErrors;
                });
            }

            let years = today.getFullYear() - birthDate.getFullYear();
            let months = today.getMonth() - birthDate.getMonth();

            if (today.getDate() < birthDate.getDate()) {
                months--;
            }

            if (months < 0) {
                years--;
                months = 12 + months;
            }

            if (years < 0) {
                years = 0;
                months = 0;
            }
            setAge({ years, months });
        } else {
            setAge({ years: 0, months: 0 });
            setLocalErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.fechaNacimiento;
                return newErrors;
            });
        }
    };

    const handleFechaNacimientoBlur = () => {
        calculateAndValidateAge();
    };

    useEffect(() => {
        validateForm(); // Se mantiene la llamada original
        // Calcular la edad si la fecha de nacimiento ya está presente al montar el componente
        if (formData.fechaNacimiento) {
            calculateAndValidateAge();
        }
    }, []); // El array vacío asegura que esto se ejecute solo una vez al montar

    useEffect(() => {
        const numHermanosVarones = parseInt(formData.numeroHermanosVarones) || 0;
        const numHermanasMujeres = parseInt(formData.numeroHermanosMujeres) || 0;
        const totalHermanos = numHermanosVarones + numHermanasMujeres;

        const updatedHermanos = Array.from({ length: totalHermanos }, (_, index) =>
            formData.hermanos[index] || { nombre: '', edad: '', lugar_ocupa: '' }
        );

        setFormData((prevState) => ({
            ...prevState,
            numeroHermanosVarones: numHermanosVarones,
            numeroHermanosMujeres: numHermanasMujeres,
            hermanos: updatedHermanos,
        }));
    }, [formData.numeroHermanosVarones, formData.numeroHermanosMujeres, setFormData]);

    const handleHermanosChange = (index, e) => {
        const { name, value } = e.target;
        const updatedHermanos = [...formData.hermanos];
        updatedHermanos[index] = { ...updatedHermanos[index], [name]: value };
        setFormData({
            ...formData,
            hermanos: updatedHermanos,
        });
    };

    // Actualiza el valor de lugarNacimiento cuando cambian los selectores
    useEffect(() => {
        if (paisNacimiento === 'Ecuador') {
            if (provinciaNacimiento && cantonNacimiento) {
                setFormData(prev => ({
                    ...prev,
                    lugarNacimiento: `Ecuador, ${provinciaNacimiento}, ${cantonNacimiento}`
                }));
            }
        } else if (paisNacimiento === 'Otro') {
            setFormData(prev => ({
                ...prev,
                lugarNacimiento: otroPaisNacimiento
            }));
        }
    }, [paisNacimiento, provinciaNacimiento, cantonNacimiento, otroPaisNacimiento, setFormData]);

    const validateForm = () => {
        // Validación para lugar de nacimiento
        if (!formData.lugarNacimiento) {
            setLocalErrors(prev => ({
                ...prev,
                lugarNacimiento: 'Por favor complete el lugar de nacimiento'
            }));
            return false;
        }
        return true;
    };

    const handleInputChangeWithValidation = (e) => {
        handleInputChange(e);
        validateForm();
    };

    const handleNoCedulaChange = (e) => {
        const noTieneCedula = e.target.checked;
        setTieneCedula(!noTieneCedula);
        
        setFormData(prev => ({
            ...prev,
            noCedula: noTieneCedula,
            cedula: noTieneCedula ? '' : prev.cedula
        }));

        if (noTieneCedula) {
            setLocalErrors(prev => ({...prev, cedula: ''}));
        } else {
            validateForm();
        }
    };

    const displayErrors = errors || localErrors;

    const inputClasses = `w-full p-1.5 rounded-lg border border-gray-300 bg-white text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`;
    const inputErrorClasses = `w-full p-1.5 rounded-lg border border-red-500 bg-white text-sm focus:border-red-500 focus:outline-none focus:ring-1 focus:ring-red-500`;

    return (
        <div className="bg-white rounded-lg p-4 max-w-4xl mx-auto">
            <h3 className="text-xl font-semibold text-gray-800 mb-4 border-b pb-2 flex items-center">
                <User className="mr-2 text-blue-500 w-4 h-4" />
                Datos de Identificación del Estudiante
            </h3>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div>
                    <label htmlFor="nombre" className="block text-xs font-medium text-gray-700 mb-1">
                        Nombre <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleInputChangeWithValidation}
                        className={displayErrors.nombre ? inputErrorClasses : inputClasses}
                        required
                        placeholder="Ingrese su nombre"
                    />
                    {displayErrors.nombre && <span className="text-red-500 text-xs">{displayErrors.nombre}</span>}
                </div>

                <div>
                    <label htmlFor="apellidos" className="block text-xs font-medium text-gray-700 mb-1">
                        Apellidos <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        id="apellidos"
                        name="apellidos"
                        value={formData.apellidos}
                        onChange={handleInputChangeWithValidation}
                        className={displayErrors.apellidos ? inputErrorClasses : inputClasses}
                        required
                        placeholder="Ingrese sus apellidos"
                    />
                    {displayErrors.apellidos && <span className="text-red-500 text-xs">{displayErrors.apellidos}</span>}
                </div>

                <div>
                    <label className="block text-xs font-medium text-gray-700 mb-1">
                        Lugar de Nacimiento <span className="text-red-500">*</span>
                    </label>
                    <div className="space-y-2">
                        <select
                            value={paisNacimiento}
                            onChange={(e) => {
                                setPaisNacimiento(e.target.value);
                                setProvinciaNacimiento('');
                                setCantonNacimiento('');
                                setOtroPaisNacimiento('');
                            }}
                            className={`w-full p-1.5 rounded-lg border ${displayErrors.lugarNacimiento ? 'border-red-500' : 'border-gray-300'} bg-white text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`}
                            required
                        >
                            <option value="">Seleccione un país</option>
                            <option value="Ecuador">Ecuador</option>
                            <option value="Otro">Otro</option>
                        </select>

                        {paisNacimiento === 'Ecuador' && (
                            <>
                                <select
                                    value={provinciaNacimiento}
                                    onChange={(e) => {
                                        setProvinciaNacimiento(e.target.value);
                                        setCantonNacimiento('');
                                    }}
                                    className={`w-full p-1.5 rounded-lg border ${!provinciaNacimiento && displayErrors.lugarNacimiento ? 'border-red-500' : 'border-gray-300'} bg-white text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`}
                                    required
                                >
                                    <option value="">Seleccione una provincia</option>
                                    {Object.keys(provinciasEcuador).map((provincia) => (
                                        <option key={provincia} value={provincia}>
                                            {provincia}
                                        </option>
                                    ))}
                                </select>

                                {provinciaNacimiento && (
                                    <select
                                        value={cantonNacimiento}
                                        onChange={(e) => setCantonNacimiento(e.target.value)}
                                        className={`w-full p-1.5 rounded-lg border ${!cantonNacimiento && displayErrors.lugarNacimiento ? 'border-red-500' : 'border-gray-300'} bg-white text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`}
                                        required
                                    >
                                        <option value="">Seleccione un cantón</option>
                                        {provinciasEcuador[provinciaNacimiento]?.map((canton) => (
                                            <option key={canton} value={canton}>
                                                {canton}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </>
                        )}

                        {paisNacimiento === 'Otro' && (
                            <input
                                type="text"
                                value={otroPaisNacimiento}
                                onChange={(e) => setOtroPaisNacimiento(e.target.value)}
                                className={`w-full p-1.5 rounded-lg border ${!otroPaisNacimiento && displayErrors.lugarNacimiento ? 'border-red-500' : 'border-gray-300'} bg-white text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500`}
                                placeholder="Ingrese el país de nacimiento"
                                required
                            />
                        )}
                    </div>
                    {displayErrors.lugarNacimiento && <span className="text-red-500 text-xs">{displayErrors.lugarNacimiento}</span>}
                </div>

                <div>
    <label htmlFor="fechaNacimiento" className="block text-xs font-medium text-gray-700 mb-1">
        Fecha de Nacimiento <span className="text-red-500">*</span>
    </label>
    <div className="flex flex-col sm:flex-row items-start sm:items-center space-y-2 sm:space-y-0 sm:space-x-2">
        <input
            type="date"
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={formData.fechaNacimiento}
            onChange={handleInputChangeWithValidation}
            onBlur={handleFechaNacimientoBlur}
            max={obtenerFechaActualLocal()}
            className={`
                ${displayErrors.fechaNacimiento ? inputErrorClasses : inputClasses}
                [&::-webkit-calendar-picker-indicator]:opacity-100
                [&::-webkit-calendar-picker-indicator]:cursor-pointer
                [&::-webkit-calendar-picker-indicator]:hover:opacity-75
                [&::-webkit-calendar-picker-indicator]:scale-110
            `}
            style={{
                colorScheme: 'light'
            }}
            required
        />
        {!displayErrors.fechaNacimiento && (age.years > 0 || age.months > 0) && (
            <div className="bg-blue-100 text-blue-600 px-2 py-2 text-xs rounded-md flex items-center whitespace-nowrap">
                <span>
                    {age.years > 0 && `${age.years} año${age.years !== 1 ? 's' : ''}`}
                    {age.years > 0 && age.months > 0 && ' y '}
                    {age.months > 0 && `${age.months} mes${age.months !== 1 ? 'es' : ''}`}
                </span>
            </div>
        )}
    </div>
    {displayErrors.fechaNacimiento && <span className="text-red-500 text-xs">{displayErrors.fechaNacimiento}</span>}
</div>

<style jsx>{`
    input[type="date"]::-webkit-calendar-picker-indicator {
        background-color: transparent;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23374151'%3e%3cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 18px 18px;
        width: 12px;
        height: 12px;
        padding: 2px;
        margin-right: 4px;
        border-radius: 2px;
        transition: all 0.2s ease;
    }
    
    input[type="date"]::-webkit-calendar-picker-indicator:hover {
        background-color: rgba(0, 0, 0, 0.05);
        transform: scale(1.05);
    }
    
    input[type="date"]:focus::-webkit-calendar-picker-indicator {
        background-color: rgba(59, 130, 246, 0.1);
    }
    
`}</style>

                {age.years > 3 && (
                    <div>
                        <label htmlFor="cedula" className="block text-xs font-medium text-gray-700 mb-1">
                            Cédula {tieneCedula && <span className="text-red-500">*</span>}
                        </label>
                        <div className="flex items-center space-x-2">
                            {tieneCedula && (
                                <input
                                    type="text"
                                    id="cedula"
                                    name="cedula"
                                    value={formData.cedula}
                                    onChange={handleInputChangeWithValidation}
                                    className={displayErrors.cedula ? inputErrorClasses : inputClasses}
                                    placeholder="Ingrese la cédula"
                                    required={tieneCedula}
                                />
                            )}
                            <div className="flex items-center">
                                <input
                                    type="checkbox"
                                    id="noCedula"
                                    checked={formData.noCedula}
                                    onChange={handleNoCedulaChange}
                                    className="mr-1"
                                />
                                <label htmlFor="noCedula" className="text-xs text-gray-600">
                                    No tiene cédula
                                </label>
                            </div>
                        </div>
                        {displayErrors.cedula && tieneCedula && <span className="text-red-500 text-xs">{displayErrors.cedula}</span>}
                    </div>
                )}

                <div>
                    <label htmlFor="direccion" className="block text-xs font-medium text-gray-700 mb-1">
                        Dirección <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        id="direccion"
                        name="direccion"
                        value={formData.direccion}
                        onChange={handleInputChangeWithValidation}
                        className={displayErrors.direccion ? inputErrorClasses : inputClasses}
                        required
                        placeholder="Ingrese su dirección"
                    />
                    {displayErrors.direccion && <span className="text-red-500 text-xs">{displayErrors.direccion}</span>}
                </div>

                <div>
                    <label htmlFor="seccion" className="block text-xs font-medium text-gray-700 mb-1">
                        Sección
                    </label>
                    <select
                        id="seccion"
                        name="seccion"
                        value={formData.seccion}
                        onChange={handleInputChange} // Using the original handleInputChange
                        className={inputClasses}
                    >
                        <option value="">Seleccione una opción</option>
                        <option value="Mañana">Mañana</option>
                        <option value="Tarde">Tarde</option>
                    </select>
                </div>

                <div>
                    <label htmlFor="numeroHermanosVarones" className="block text-xs font-medium text-gray-700 mb-1">
                        N° Hermanos Varones
                    </label>
                    <input
                        type="number"
                        id="numeroHermanosVarones"
                        name="numeroHermanosVarones"
                        value={formData.numeroHermanosVarones || 0}
                        onChange={handleInputChange}
                        className={inputClasses}
                        min="0"
                    />
                </div>

                <div>
                    <label htmlFor="numeroHermanosMujeres" className="block text-xs font-medium text-gray-700 mb-1">
                        N° Hermanas Mujeres
                    </label>
                    <input
                        type="number"
                        id="numeroHermanosMujeres"
                        name="numeroHermanosMujeres"
                        value={formData.numeroHermanosMujeres || 0}
                        onChange={handleInputChange}
                        className={inputClasses}
                        min="0"
                    />
                </div>

                <div>
                    <label htmlFor="viveCon" className="block text-xs font-medium text-gray-700 mb-1">
                        Vive con
                    </label>
                    <select
                        id="viveCon"
                        name="viveCon_select"
                        value={viveConSelection}
                        onChange={customHandleInputChange}
                        className={inputClasses}
                    >
                        <option value="">Seleccione una opción</option>
                        <option value="padre">Padre</option>
                        <option value="madre">Madre</option>
                        <option value="padre y madre">Padre y Madre</option>
                        <option value="abuelos">Abuelos</option>
                        <option value="tios">Tíos</option>
                        <option value="otra">Otra</option>
                    </select>
                    {viveConSelection === 'otra' && (
                        <div className="mt-2">
                            <input
                                type="text"
                                name="viveConOtra"
                                value={formData.viveConOtra || ''}
                                onChange={customHandleInputChange}
                                className={inputClasses}
                                placeholder="Especifique con quién vive"
                            />
                        </div>
                    )}
                </div>

                <div>
                    <label htmlFor="pasaTiempoCon" className="block text-xs font-medium text-gray-700 mb-1">
                        Pasa tiempo con
                    </label>
                    <select
                        id="pasaTiempoCon"
                        name="pasaTiempoCon_select"
                        value={pasaTiempoConSelection}
                        onChange={customHandleInputChange}
                        className={inputClasses}
                    >
                        <option value="">Seleccione una opción</option>
                        <option value="madre">Madre</option>
                        <option value="padre">Padre</option>
                        <option value="abuelos">Abuelos</option>
                        <option value="tios">Tíos</option>
                        <option value="hermanos">Hermanos</option>
                        <option value="otra">Otra</option>
                    </select>
                    {pasaTiempoConSelection === 'otra' && (
                        <div className="mt-2">
                            <input
                                type="text"
                                name="pasaTiempoOtra"
                                value={formData.pasaTiempoOtra || ''}
                                onChange={customHandleInputChange}
                                className={inputClasses}
                                placeholder="Especifique con quién pasa el tiempo"
                            />
                        </div>
                    )}
                </div>

                <div>
                    <label htmlFor="observacionesEntorno" className="block text-xs font-medium text-gray-700 mb-1">
                        Observaciones familiares
                    </label>
                    <select
                        id="observacionesEntorno"
                        name="observacionesEntorno"
                        value={formData.observacionesEntorno}
                        onChange={handleInputChange}
                        className={inputClasses}
                    >
                        <option value="">Seleccione una opción</option>
                        <option value="padres separados">Padres separados</option>
                        <option value="divorciados">Divorciados</option>
                        <option value="fallecidos">Fallecidos</option>
                        <option value="otros compromisos">Otros compromisos</option>
                    </select>
                </div>
            </div>

            {formData.hermanos && formData.hermanos.length > 0 && (
                <div className="bg-gray-50 p-3 rounded-md mt-4">
                    <h4 className="text-sm font-semibold text-gray-700 mb-2">
                        Datos de los Hermanos
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                        {formData.hermanos.map((hermano, index) => (
                            <div key={index} className="grid grid-cols-3 gap-2">
                                <input
                                    type="text"
                                    name="nombre"
                                    value={hermano.nombre}
                                    onChange={(e) => handleHermanosChange(index, e)}
                                    placeholder="Nombre"
                                    className={inputClasses}
                                />
                                <input
                                    type="number"
                                    name="edad"
                                    value={hermano.edad}
                                    onChange={(e) => handleHermanosChange(index, e)}
                                    placeholder="Edad"
                                    className={inputClasses}
                                />
                                <input
                                    type="text"
                                    name="lugar_ocupa"
                                    value={hermano.lugar_ocupa}
                                    onChange={(e) => handleHermanosChange(index, e)}
                                    placeholder="Lugar"
                                    className={inputClasses}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DatosPersonales;